<template>
  <!-- 人才招聘,人才需求 -->
  <div class="box">
    <DetailsHead img="./img/bj4.png" title="人才需求" remarks="Demand Talents" />

    <TopBreadcrumb :data="[
        { label: '需求信息', path: '/dataOpen/ralentRecruitment' },
        { label: '人才需求', path: '/dataOpen/ralentRecruitment' },
        { label: '详情' },
      ]" />

    <div class="details-con" v-loading="loading">
      <div class="details-head">
        <div class="title">{{data.position}}</div>
        <div class="more">
          <div>阅读量：{{ data.count }}&nbsp;&nbsp;有效日期: {{new Date(data.effectiveDate).formatCode('YYYY-MM-DD')}} </div>
            <div>【<span @click="$print()">打印</span>】 收藏 </div>
        </div>
      </div>
      <p class="title-name">招聘信息：</p>
      <table cellspacing="0" cellpadding="0" border="0" width="100%" class="tb_job">
        <tbody>
          <tr>
            <td class="tdtit">招聘职位：</td>
            <td class="tdbox" colspan="5">
              <h1>{{data.position}}</h1>
            </td>
          </tr>
          <tr>
            <td class="tdtit">人数：</td>
            <td class="tdbox">{{data.number}}</td>
            <td class="tdtit">招聘对象：</td>
            <td class="tdbox">{{data.object}}</td>
            <td class="tdtit">工作地区：</td>
            <td class="tdbox">{{data.workArea}}</td>
          </tr>
          <tr>
            <td class="tdtit">薪资：</td>
            <td class="tdbox">{{data.salary}}</td>
            <td class="tdtit">住房：</td>
            <td class="tdbox">{{data.housing == 0 ? '无' : '有'}}</td>
            <td class="tdtit">专业要求：</td>
            <td class="tdbox">{{data.major}}</td>
          </tr>
          <tr>
            <td class="tdtit">学历：</td>
            <td class="tdbox">{{data.education}}</td>
            <td class="tdtit">年龄：</td>
            <td class="tdbox">{{data.age}}</td>
            <td class="tdtit">性别：</td>
            <td class="tdbox">{{data.gender == 0 ? '男' : data.gender == 1 ? '女生' : '不限'}}</td>
          </tr>
          <tr>
            <td class="tdtit">有效日期：</td>
            <td class="tdbox">{{new Date(data.effectiveDate).formatCode('YYYY.MM.DD')}}</td>
            <td class="tdtit">工作经验：</td>
            <td class="tdbox" colspan="3">{{data.experience}}</td>
          </tr>
          <tr>
            <td class="tdtit">具体要求：</td>
            <td class="tdbox content" colspan="5">
              <p class="content-box" v-html="data.details"></p>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="title-name">企业信息：</p>
      <table cellspacing="0" cellpadding="0" border="0" width="100%" class="tb_job">
        <tbody>
          <tr>
            <td class="tdtit">企业名称：</td>
            <td class="tdbox" colspan="5">{{data.enterpriseName}}</td>
          </tr>
          <tr>
            <td class="tdtit">企业联系人：</td>
            <td class="tdbox" colspan="5">{{data.enterpriseHr}}</td>
          </tr>
          <tr>
            <td class="tdtit">企业联系电话：</td>
            <td class="tdbox" colspan="5">{{data.enterpriseTel}}</td>
          </tr>
          <tr>
            <td class="tdtit">企业邮箱：</td>
            <td class="tdbox" colspan="5">{{data.enterpriseEmail}}</td>
          </tr>
          <tr>
            <td class="tdtit">企业官网：</td>
            <td class="tdbox" colspan="5">{{data.enterpriseWeb}}</td>
          </tr>
          <tr>
            <td class="tdtit">企业地点：</td>
            <td class="tdbox" colspan="5">{{data.enterpriseAddress}}</td>
          </tr>
          <tr>
            <td class="tdtit">企业简介：</td>
            <td class="tdbox content" colspan="5">
              <p>{{data.enterpriseDetail}}</p>
            </td>
          </tr>
        </tbody>
      </table>
      <PersonnelBox style="width: calc(100% - 14px);" :data="data" />
    </div>
  </div>
</template>

<script>
import { fileName } from "@/utils";
import TopBreadcrumb from "@/components/TopBreadcrumb.vue";
import DetailsHead from "@/components/DetailsHead.vue";

import { ralentRecruitment } from "@/api/dataOpen.js";
import PersonnelBox from "../comp/PersonnelBox.vue";
const { getDocumentDetails } = ralentRecruitment;
export default {
  components: { DetailsHead, TopBreadcrumb, PersonnelBox },
  data() {
    return {
      fileName,
      loading: false,
      data: {},
    };
  },
  mounted() {
    this.loading = true;
    getDocumentDetails(this.$route.params.id)
      .then((res) => {
        this.data = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/less/details-box.less");

.title-name {
  display: block;
  margin-top: 10px;
  font-size: 17px;
  color: #333;
  text-align: left;
  width: 100%;
  padding: 10px;
}
.tb_job {
  line-height: 50px;
  background: #a6dcf6;
}
.tb_job td {
  padding: 3px 8px;
  background: #ffffff;
}
.tb_job td h1 {
  text-align: left;
}
.tb_job .tdtit {
  padding: 3px 8px;
  width: 15%;
  font-size: 12px;
  color: #666;
  text-align: right;
  background: #e3f5ff;
  border: 1px solid #a6dcf6;
}
.tb_job .tdbox {
  padding: 3px 8px;
  font-family: "Arial";
  border: 1px solid #a6dcf6;
}
.tb_job .tdbox.content p {
  line-height: 37px;
  // 处理换行
  white-space: pre-wrap;
}
.tb_job .tdtit strong {
  color: #2096db;
}
</style>